import styled from 'styled-components';

export const StylesPages = styled.section`
  min-height: 100vh;
`;
export const StylesPageUser = styled.section`
  display: flex;
`;
